module.exports = __webpack_public_path__ + "img/checkmark.1484a869.svg";